import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useStudentAuth } from '@/context/StudentAuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { processGoogleSession } = useStudentAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL hash
        const hash = location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL');
          navigate('/uac-desk/login');
          return;
        }

        const sessionId = sessionIdMatch[1];
        
        // Process the session with backend
        const user = await processGoogleSession(sessionId);
        
        // Redirect to dashboard with user data
        navigate('/uac-desk/dashboard', { 
          replace: true,
          state: { user }
        });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/uac-desk/login');
      }
    };

    processSession();
  }, [location.hash, navigate, processGoogleSession]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-ux-violet via-ux-cyan to-ux-blue">
      <div className="text-center text-white">
        <Loader2 className="w-12 h-12 animate-spin mx-auto mb-4" />
        <p className="text-lg">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
